// The app: the sign-in screen while signed out, a moment of loading until the account has answered, then the window.

import { useEffect } from "react";
import { currentLanguage, t, useLanguage } from "../i18n";
import { useModelState } from "./context";
import type { Model } from "./model";
import { SignIn } from "./SignIn";
import { Window } from "./Window";
import "./styles/tokens.css";
import "./styles/app.css";
import "./styles/more.css";
import "./styles/habits.css";

export function App({ model }: { model: Model }) {
  const state = useModelState(model);
  const language = useLanguage();
  useEffect(() => {
    document.documentElement.lang = currentLanguage();
  }, [language]);
  if (!state.user) return <SignIn auth={model.auth} />;
  if (state.status === "loading") return <div className="loading" role="status">{t("Loading your to-dos…")}</div>;
  if (state.status === "blocked") {
    return (
      <div className="loading" role="alert">
        <p>{t("Your account needs a newer version of Todolix.")}</p>
        <button className="mint-button" onClick={() => location.reload()}>{t("Reload")}</button>
      </div>
    );
  }
  return <Window model={model} state={state} />;
}
